import { render, staticRenderFns } from "./PollsGrid.vue?vue&type=template&id=3061aab0"
import script from "./PollsGrid.vue?vue&type=script&lang=js"
export * from "./PollsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports